































import Component from "vue-class-component";
import { Prop, Vue } from "vue-property-decorator";
import Radio from "./radio.vue";
import moment from "moment";
@Component({
  components: { Radio },
  methods: {
    getList() {},
  },
})
export default class indexPage extends Vue {
  moment = moment;
  mounted() {
    document.title = "消费记录";
    console.log(this.hasSelect, 222);
  }
  @Prop({
    type: Boolean,
    default: false,
  })
  public hasSelect: boolean;
  @Prop({
    type: Boolean,
    default: false,
  })
  public isSelect: boolean;
  @Prop({
    type: Boolean,
    default: false,
  })
  public hasHistoryBtn: boolean;
  @Prop({
    type: Object,
    default: {},
  })
  public info: boolean;
}
